<template>
  <!-- <v-app :style="appBackground"> -->
  <v-app>
    <!-- <v-app-bar app style="background-color: black; border-bottom: 1px solid; border-color: #a07800"> -->
    <!-- <v-app-bar app :style="appBarBackground"> -->
    <!-- <v-app-bar app> -->
    <v-app-bar app v-if="user !== null && user !== undefined">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title width="300px" class="headline text-uppercase">
        <span>TAP</span>
        <span class="font-weight-light red--text">LAW</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div>
        <!-- <v-tabs centered background-color="black" color="#18CAE6"> -->
        <v-tabs centered background-color=" transparent">
          <v-tab
            v-for="(item, index) in this.menuItems"
            :key="index"
            class="hidden-md-and-down"
            :to="item.link"
          >
            {{ item.title }}
          </v-tab>
        </v-tabs>
      </div>
      <v-spacer></v-spacer>

      <!-- <div
        v-for="(item, index) in this.menuItems"
        :key="index"
        class="hidden-xs-only"
      >
        <v-btn rounded outlined class="ma-2" text :to="item.link">{{
          item.title
        }}</v-btn>
      </div> -->
      <v-btn text v-if="userIsAuthenticated" @click="onLogout">
        <v-icon class="hidden-xs-only">mdi-exit-to-app</v-icon>
        <span class="mr-2">LOGOUT</span>
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      absolute
      clipped
      style="border-right: 1px solid; border-color: #d8e2eb"
    >
      <v-list dense>
        <v-list-item
          v-for="(item, index) in menuItems"
          :key="index"
          :to="item.link"
          color="#d8e2eb"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="onLogout">
          <v-list-item-action>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>LOGOUT</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <!-- <HelloWorld/> -->
      <router-view></router-view>
    </v-main>
    <v-footer padless>
      <v-col class="text-center" cols="12">
        Copyright 2022 — <strong>Taplaw, Inc.</strong>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
/**
 *
 *
 *
 * this component is the route component that presents all other components
 * to the user within the router-view component
 * the router-view works in tandem with the router/index.js file
 *
 * teh menue items should probably reflect the menue items in "Matter" cmponent
 * but I don't knwo how that should look yet so I haven't done it yet
 *
 *
 *
 */

// import HelloWorld from "./components/HelloWorld";
// import * as firebase from "firebase";

export default {
  name: "App",
  components: {
    // HelloWorld
  },
  data: () => ({
    drawer: false
    // appBackground: "background-color: #d8e2eb;"
    // appBarBackground:
    //   "background-color: black; border-bottom: 1px solid; border-color: #18CAE6"
    // "background-color: black; border-bottom: 1px solid; border-color: grey"
    // role: null
  }),
  computed: {
    menuItems() {
      let menuItems = [
        { icon: "mdi-account-circle", title: "Log In", link: "/login" },
        { icon: "mdi-lock-open", title: "Sign Up", link: "/signup" }
      ];
      if (this.userIsAuthenticated && this.role === "admin") {
        let menuItems = [
          { icon: "mdi-home", title: "Home", link: "/" },
          {
            icon: "mdi-folder-multiple",
            title: "View Matters",
            link: "/matters"
          },
          {
            icon: "mdi-folder-plus",
            title: "Create Matter",
            link: "/matters/new"
          },
          { icon: "mdi-account-outline", title: "Profile", link: "/profile" },
          {
            icon: "mdi-account-plus-outline",
            title: "Create New User",
            link: "/new-user-admin"
          },
          {
            icon: "mdi-account-plus-outline",
            title: "Admin",
            link: "/admin"
          }
        ];
        return menuItems;
      }

      if (this.userIsAuthenticated && this.role !== "admin") {
        let menuItems = [];
        return menuItems;
      }

      if (!this.userIsAuthenticated && this.role == "admin") {
        let menuItems = [
          { icon: "mdi-account-circle", title: "Log In", link: "/login" },
          { icon: "mdi-lock-open", title: "Sign Up", link: "/signup" }
        ];
        return menuItems;
      }

      if (this.$route.path === "/contents-list") {
        console.log("this is the contents list component");
        let menuItems = [];
        return menuItems;
      }

      // let menuItems = [
      //   { icon: "mdi-account-circle", title: "Log In", link: "/login" },
      //   { icon: "mdi-lock-open", title: "Sign Up", link: "/signup" }
      // ];
      // if (this.userIsAuthenticated) {
      //   menuItems = [
      //     { icon: "home", title: "Home", link: "/" },
      //     { icon: "folder", title: "View Matters", link: "/matters" },
      //     { icon: "add", title: "Create Matter", link: "/matters/new" },
      //     { icon: "person", title: "Profile", link: "/profile" }
      //   ];
      // }
      return menuItems;
    },
    user() {
      return this.$store.getters.user;
    },
    userIsAuthenticated() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    },
    role() {
      return this.$store.getters.role;
    }
    // userIsAdmin() {
    //   return (
    //     this.$store.getters.user !== null &&
    //     this.$store.getters.user !== undefined
    //   );
    // this.role == "admin"
  },

  // userIsClient() {
  //   return (
  //     this.$store.getters.user !== null &&
  //     this.$store.getters.user !== undefined &&
  //     // this.role == "client"
  //   );
  // }
  // },
  methods: {
    onLogout() {
      if (this.$route.name === "ContentsList") {
        this.$store.dispatch("logout");
        this.$router.push("/contents-list");
      } else {
        this.$store.dispatch("logout");

        this.$router.push("/");
        // this.appBackground = "background-color: black;";
        // this.appBarBackground =
        //   "background-color: black; border-bottom: 1px solid; border-color: #18CAE6";
        // this.$vuetify.theme.dark = true;
        //   location.reload();
        // } else {
        //   this.$router.push("/");
      }
    }
  },
  created() {
    console.log(this.$route);

    // if (this.$route.name === "ContentsList") {
    //   this.appBackground = "background-color: #E3F2FD;";
    //   this.appBarBackground =
    //     "background-color: white; border-bottom: 1px solid; border-color: #18CAE6";
    //   this.$vuetify.theme.dark = false;
    // }

    // if (this.$route.path === "/") {
    //   this.appBackground = "background-color: black;";
    //   this.appBarBackground =
    //     "background-color: black; border-bottom: 1px solid; border-color: #18CAE6";
    //   this.$vuetify.theme.dark = true;
    // }
    // let user = this.$store.getters.user;
    // let firm = this.$store.getters.firm;
    // console.log("hello from created in app.vue");
    // console.log("user", user);
    // console.log("firm", firm);
    // firebase
    //   .auth()
    //   .currentUser.getIdTokenResult()
    //   .then(idTokenResult => {
    //     // Confirm the user is an Admin.
    //     if (idTokenResult.claims.admin) {
    //       // Show admin UI.
    //       console.log("user is admin");
    //       this.role = "admin";
    //     } else if (idTokenResult.claims.client) {
    //       // Show regular user UI.
    //       console.log("user is client");
    //       this.role = "client";
    //     } else {
    //       console.log("user is neither admin nor client");
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error);
    //   });
  }
};
</script>
